<template>
    <div class="content-view">
        <h2 class="fs-24 text-center fc-theme">DSR智能计算器</h2>
        <p class="subtitle text-center fs-14 fc-666">输入当前DSR基础数据与目标数据，自动计算还需要多少单5分的好评！店铺单量目标一目了然~</p>
        <top-price code="dsr"></top-price>
        <div class="marginT-20 flex form">
            <div class="flex-1">
                <div class="item">
                    宝贝与描述相符：
                    <el-input v-model="desc.now_scores" @change="maxCount('desc', 'now_scores')" size="mini" type="text"></el-input>分，已
                    <el-input v-model="desc.already_have" size="mini" type="text"></el-input>人评分，输入目标得分：
                    <el-input v-model="desc.target_score" @change="maxCount('desc', 'target_score')" size="mini" type="text"></el-input>分。
                </div>
                <div class="item">
                    宝贝与服务态度：
                    <el-input v-model="manner.now_scores" @change="maxCount('manner', 'now_scores')" size="mini" type="text"></el-input>分，已
                    <el-input v-model="manner.already_have" size="mini" type="text"></el-input>人评分，输入目标得分：
                    <el-input v-model="manner.target_score" @change="maxCount('manner', 'target_score')" size="mini" type="text"></el-input>分。
                </div>
                <div class="item">
                    物流服务的质量：
                    <el-input v-model="quality.now_scores" @change="maxCount('quality', 'now_scores')" size="mini" type="text"></el-input>分，已
                    <el-input v-model="quality.already_have" size="mini" type="text"></el-input>人评分，输入目标得分：
                    <el-input v-model="quality.target_score" @change="maxCount('quality', 'target_score')" size="mini" type="text"></el-input>分。
                </div>
            </div>
            <div class="right-result">
                <div class="item">还需要：<span class="fc-theme">{{desc.need ? desc.need :'？'}} 单</span> &nbsp; 5 分评分</div>
                <div class="item">还需要：<span class="fc-theme">{{manner.need ? manner.need :'？'}} 单</span> &nbsp; 5 分评分</div>
                <div class="item">还需要：<span class="fc-theme">{{quality.need ? quality.need :'？'}} 单</span> &nbsp; 5 分评分</div>
            </div>
        </div>
        <div class="submit text-center">
            <div class="marginT-20">
                <el-button @click="onSubmit" type="danger">一键计算查询</el-button>
            </div>
        </div>

        <div class="tips flex">
            <div>
                温馨提示：
            </div>
            <div class="tip-lis">
                <div>1、目标得分输入不能小于当前店铺评分，也不能大于5，否则计算结果无意义哦~</div>
                <div class="fc-theme">2、当DSR评分在下降时，或需要提升到行业水平及以上，需要计算单量进行补救</div>
                <div>3、根据你店铺现在的DSR得分、评分的人数，和你预期想要达到的动态分数，计算所需单量</div>
            </div>
        </div>

        <div class="desc marginT-50">
            <h3 class="fc-theme fs-20 text-center">淘宝动态评分计算器使用说明</h3>
        </div>
        <div class="tip-card marginT-20">
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">如何查看店铺动态评分?</span>
                </div>
                <div>
                    <img src="https://pic.rmb.bdstatic.com/bjh/e1e4a9f497d2170efe18228539db4127.png">
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">如何提高店铺动态评分?</span>
                </div>
                <div class="li-content">
                    1、提高对顾客的服务态度，发货速度，完善商品的详情描述。让顾客舒心购物；<br>
                    2、当顾客收到宝贝后，及时主动联系顾客是否满意。从而提醒顾客好评，并打5分；<br>
                    3、使用好评返现，在宝贝快递报告里面放详细的如何写评价来返现；<br>
                    4、对买家进行评估，对于一些经常差评的买家进行拒绝销售，看看这个买家是不是差评师或者喜欢经常给人评价差评的；<br>
                    5、淘宝规则：买家已评论但卖家不评论，买家评论在确定付款后15天才会出现。卖家在淘宝买家评价查看看到买家是中差评或者很不好的评价内容，就安排客服及时跟进解决；<br>
                    <span class="fc-theme">
                        6、找人或者加入一些互刷平台来刷动态评分，目前基本上都是用一款1元宝贝大量拍给5分，达到了就马上删除这个宝贝来避免淘宝检查，有一定的危险性；<br>
                        7、DSR需要特别注意的事情：如果买家不评价，系统默认评价是不计算的，而不是认为会自动给5分，淘宝卖家服务很多自动；好评的软件是非常坑人的，你给用户自动好评了，但是用户不给你评价，你就白丢了这单，所以一定要客服跟进要买家尽量给5分评价。<br>
                    </span>
                    8、接口合作请加微信{{getkfWx()}}
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header">
                    <span class="fs-16">淘宝动态评分规则解读?</span>
                </div>
                <div class="li-content">
                    <span class="fw-bold">淘宝动态评分规则：</span><br>
                    1、淘宝店铺动态评分满分是5分，但是当<span class="fc-theme">店铺动态评分小于4.4分</span>时，网店内的所有宝贝<span class="fc-theme">将会受到搜索降权的处理</span>；<br>
                    2、同一位客户每月最多只能计算3次动态评分，给多了不计分；<br>
                    3、同一个订单单号，买再多的商品也只计算1次动态评分，如果想得到多次评分，可以建议顾客分单购买；<br>
                    4、淘宝动态评分在双方互评后，半个小时将会显示，特殊情况会拖延至24-48小时；<br>
                    5、淘宝店铺动态评分任何人都无法修改，并且也不能查看是谁评的分。<br>
                    <span class="fw-bold">天猫动态评分规则：</span><br>
                    1、在每个自然月中(以交易成功时间为准)，相同买卖家之间若存在3笔以上交易，则只有最先评价的三笔生效计分（非炒作信誉），后面评价的评价生效但不再计分；<br>
                    2、若在14天内相同买家和卖家之间就同一商品有多笔支付宝交易，则最近1笔交易（非炒作信誉）买家给卖家的评价方可生效计分，之前生效计分的评价将修改为生效不计分；<br>
                    3、天猫交易中系统自动回予买家好评数计分不受约束，即对于每笔订单中的每一个商品，系统将自动回予买家一个生效计分的好评。
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                desc: {
                    now_scores: 4,
                    already_have: 100,
                    target_score: 4.8,
                    need: 400
                },
                manner: {
                    now_scores: 4,
                    already_have: 100,
                    target_score: 4.8,
                    need: 400
                },
                quality: {
                    now_scores: 4,
                    already_have: 100,
                    target_score: 4.8,
                    need: 400
                }
            }
        },
        methods: {
            async onSubmit() {
                if (!localStorage.token) {
                    this.$bus.emit('openLogin')
                    return
                }
                window.checkDiscountPackage("dsr")
                this.desc.need = await this.getData(this.desc)
                this.manner.need = await this.getData(this.manner)
                this.quality.need = await this.getData(this.quality)
            },
            maxCount(obj, key) {
                if (this[obj][key] && Number(this[obj][key]) > 5) {
                    this[obj][key] = 5
                }
            },
            async getData(obj) {
                if (!obj.now_scores || !obj.already_have || !obj.target_score) {
                    this.$message.error('请填写完整')
                    return
                }
                if (obj.now_scores > 5 || obj.target_score > 5) {
                    this.$message.error('请正确输入')
                    return
                }
                if (obj.target_score <= obj.now_scores) {
                    this.$message.error('目标评分参数不能小于等于当前评分参数')
                    return
                }
                const data = await this.$fetch('/api/proxy/web/dsr', {...obj})
                if (data.code == 0 && data.data) {
                    if( data.data.length == 0 ) {
                        return 0
                    }
                    return data.data
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.form {
    font-size: 14px;
    padding-top: 20px;
    padding-bottom: 20px;
    .el-input {
        width: 90px;
        margin: 0 5px;
    }
    .item {
        display: flex;
        align-items: center;
        & + .item {
            margin-top: 20px;
        }
    }
    .right-result {
        flex-basis: 350px;
        border-left: 1px solid #e0e0e0;
        .item {
            padding-left: 50px;
            height: 28px;
            line-height: 28px;
        }
    }
}
.tips {
    margin-top: 30px;
    padding-left: 150px;
}
.box-card {
    margin-top: 25px;
    .li-content {
        line-height: 24px;
        // font-size: 16px;
    }
}
</style>
<style lang="scss">
.tip-card .el-card__header {
    padding: 10px 20px;
}
</style>
